import React from "react";
import { cn } from "@/lib/utils";

interface InteractiveHoverButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
}

const InteractiveHoverButton = React.forwardRef<
  HTMLButtonElement,
  InteractiveHoverButtonProps
>(({ text = "Button", className, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn(
        "group relative w-auto cursor-pointer overflow-hidden rounded-full border bg-transparent px-8 py-3 text-center font-semibold text-sm whitespace-nowrap",
        className
      )}
      {...props}
    >
      <span className="relative z-20 transition-colors duration-300 group-hover:text-black">
        {text}
      </span>
      <div className="absolute inset-0 w-0 transition-all duration-300 group-hover:w-full" style={{ backgroundColor: '#ffbc00' }}></div>
    </button>
  );
});

InteractiveHoverButton.displayName = "InteractiveHoverButton";

export { InteractiveHoverButton };
